import { authSession } from 'src/auth/auth-session';
import { ErrorMessage } from 'src/shared/enum/ErrorMessage';
import { Building } from 'src/shared/types/building';
import { Room } from 'src/shared/types/room';

import { BasketUser } from '../basketService';
import { studentBookingClient } from '../client';
import { StudentBookingSuccessResponse } from '../types';

import { BookingServiceEndpoints } from './constants';
import {
    BookingCalculatedDetails,
    BookingCalculationRequest,
    CreateStlRequest,
    CreateStlResponse,
    PostCreateStlSuccessResponse,
    BookingSfStatusResponse,
    GetCheckBookingStatusSuccessResponse,
    PostBookingCalculateServiceSuccessResponse,
} from './types';

export const calculateBookingDetails = async (
    bookingDetails: BookingCalculationRequest
): Promise<BookingCalculatedDetails> => {
    const { data: response } =
        await studentBookingClient.post<PostBookingCalculateServiceSuccessResponse>(
            BookingServiceEndpoints.PostCalculateBookingDetails,
            bookingDetails
        );

    return response.data;
};

export const checkBookingStatus = async (
    bookingRecordId: string
): Promise<Record<string, string>> => {
    const { data: response } = await studentBookingClient.get<GetCheckBookingStatusSuccessResponse>(
        `${BookingServiceEndpoints.BaseUrl}/${bookingRecordId}/status`
    );
    return response.data;
};

export const checkBookingCreatedSf = async (
    bookingRecordId: string
): Promise<BookingSfStatusResponse> => {
    const url = BookingServiceEndpoints.CheckBookingProcessedSalesforce.replace(
        '{bookingRecordId}',
        bookingRecordId
    );

    const { data } = await studentBookingClient.get<BookingSfStatusResponse>(url);
    return data;
};

export const getRoomByVitaRef = async (
    vitaRef: string
): Promise<{ room: Room; building: Building }> => {
    const token = await authSession();
    if (!token) throw new Error(ErrorMessage.AUTH_ID_ERROR);

    const { data: response } = await studentBookingClient.get<
        StudentBookingSuccessResponse<{ room: Room; building: Building }>
    >(`${BookingServiceEndpoints.BaseUrl}/${vitaRef}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const UpdateOccupantDetails = async (details: { vitaRef: string; occupant: BasketUser }) => {
    const token = await authSession();
    if (!token) throw new Error(ErrorMessage.AUTH_ID_ERROR);

    const { data: response } = await studentBookingClient.post<StudentBookingSuccessResponse<null>>(
        BookingServiceEndpoints.PostUpdateOccupantDetails,
        details,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};

export const createStl = async (stlDetails: CreateStlRequest): Promise<CreateStlResponse> => {
    const { data: response } = await studentBookingClient.post<PostCreateStlSuccessResponse>(
        BookingServiceEndpoints.PostCreateStl,
        stlDetails
    );

    return response.data;
};
